import React__default from 'react';
import { useSlateStatic, useFocused } from 'slate-react';
import styles from './Link.scss.mjs';
import { usePopover } from '../../../../../../../Popover/hooks/usePopover.mjs';
import { isLinkSelected } from '../../queries/isLinkSelected.mjs';
import { hasText } from '../../queries/hasText.mjs';
import { isRangeWithinVoid } from '../../../../../../core/queries/isRangeWithinVoid.mjs';
import { Popover } from '../../../../shared/components/Popover/Popover.mjs';

function Link({
  attributes,
  element,
  children,
  renderPopover
}) {
  const editor = useSlateStatic();
  const {
    activatorAccessibilityProps,
    popoverAccessibilityProps
  } = usePopover({
    ariaHasPopup: 'menu'
  });
  const focused = useFocused();
  const active = Boolean(renderPopover) && focused && isLinkSelected(editor, element) && hasText(editor) && !isRangeWithinVoid(editor, editor.selection);
  const popover = renderPopover ? renderPopover(editor, element) : null;
  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement("a", Object.assign({}, attributes, {
    href: element.url,
    title: element.title,
    style: attributes.style,
    className: styles.Link
  }, activatorAccessibilityProps), children), popover ? /*#__PURE__*/React__default.createElement(Popover, Object.assign({
    active: active,
    accessibilityAnnouncement: popover.accessibilityAnnouncement
  }, popoverAccessibilityProps), popover.markup) : null);
}

export { Link };
